// ── lazyWithReload — ленивый экран, который переживает выход новой версии ────
// После публикации старые файлы-части сайта исчезают; если открыть экран, который
// ещё не грузился, браузер получит ошибку загрузки. Тогда один раз перезагружаем
// страницу — и экран открывается уже из новой версии.

import { lazy } from "react";

// TextReader весит ~2k строк + тащит tiny-segmenter. Лениво грузим — экран
// чтения открывается реже плеера, нет смысла включать его в initial bundle.
// После выхода новой версии старых файлов кода на сервере уже нет: если догрузка
// не удалась — один раз перезагружаемся (не чаще раза в минуту), а не показываем ошибку.
export const lazyWithReload = (load) => lazy(() => load().catch((e) => {
  let last = 0;
  try { last = +sessionStorage.getItem("ac_chunk_reload") || 0; } catch {}
  if (Date.now() - last > 60000) {
    try { sessionStorage.setItem("ac_chunk_reload", String(Date.now())); } catch {}
    window.location.reload();
    return new Promise(() => {});
  }
  throw e;
}));
